import axios from 'axios'
console.error('window.deployBaseRoute',window.deployBaseRoute)
const deployBaseRoute = window.deployBaseRoute || '/'
axios.interceptors.request.use((config) => {
  config.baseURL = deployBaseRoute
  return config
})
export default axios